import { render } from "./BlocksLoadingSkeleton.vue?vue&type=template&id=4d7329d2"
import script from "./BlocksLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./BlocksLoadingSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__